export class AppSettings {
    public mpApiBaseUrl: string = '';
}